export default function ArticleCards() {
  const articles = [
    {
      title: 'Superbuy Spreadsheet Complete Guide 2026',
      subtitle: 'Everything you need to know about using the spreadsheet',
      slug: '/superbuy-spreadsheet-guide',
      bgImage: 'https://readdy.ai/api/search-image?query=Open%20laptop%20displaying%20neatly%20organized%20spreadsheet%20grid%20on%20light%20wood%20desk%20surrounded%20by%20a%20steaming%20coffee%20cup%20notepad%20and%20pen%20soft%20morning%20light%20through%20sheer%20curtains%20lifestyle%20workspace%20photography%20warm%20tones%20clean%20composition%20cozy%20productive%20atmosphere&width=500&height=350&seq=article-guide-v3&orientation=landscape',
    },
    {
      title: 'How To QC Products Like a Pro',
      subtitle: 'Master quality control before you buy',
      slug: '/qc-guide',
      bgImage: 'https://readdy.ai/api/search-image?query=Professional%20fashion%20designer%20inspecting%20garment%20quality%20with%20ruler%20and%20fabric%20swatch%20on%20cutting%20table%20bright%20clean%20studio%20lighting%20topdown%20angle%20detail%20oriented%20quality%20control%20product%20inspection%20editorial%20photography%20modern%20aesthetic&width=500&height=350&seq=article-qc-v3&orientation=landscape',
    },
    {
      title: 'Is Superbuy Spreadsheet Safe?',
      subtitle: 'Safety tips and trusted shopping advice',
      slug: '/safety-guide',
      bgImage: 'https://readdy.ai/api/search-image?query=Shield%20security%20symbol%20icon%20placed%20next%20to%20folded%20fresh%20clothing%20items%20on%20warm%20textured%20linen%20background%20soft%20natural%20daylight%20concept%20of%20consumer%20protection%20and%20trusted%20shopping%20experience%20minimal%20editorial%20style%20clean%20composition&width=500&height=350&seq=article-safe-v3&orientation=landscape',
    },
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full border border-accent-300/50 bg-accent-100/60 text-accent-700 text-xs font-medium mb-4">
            Shopping Resources
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-3">
            Learn &amp; Shop Smarter
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Read our in-depth guides to make the most out of your Superbuy spreadsheet experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article) => (
            <a
              key={article.title}
              href={article.slug}
              className="group relative aspect-[4/3] rounded-2xl overflow-hidden cursor-pointer"
            >
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                style={{ backgroundImage: `url('${article.bgImage}')` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/25 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
                <h3 className="text-background-50 font-heading text-lg md:text-xl font-semibold leading-snug mb-1.5">
                  {article.title}
                </h3>
                <p className="text-background-50/80 text-xs md:text-sm leading-relaxed">
                  {article.subtitle}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}